import { Event } from "../../api/grpc/desk/ggevent/ggevent";

// this object defines event data that are static
export const deskEvent: Event = {
  title: "Desk Reservation",
  description: "description",
  locations: [],
  attendees: [],
  isPrivate: false,
  extendedProperties: {},
  metaData: {},
  creationTime: "",
  providerType: "",
  updateTime: "",
  workplaceID: "",
  checkInRequiredStatus: 1,
  eventCheckInStatus: 1,
  workplaceLocationPath: [],
  tags: [],
  isOnlineMeeting: false,
  onlineMeetingUrl: "",
  isCheckOut: false,
  headcount: 0,
  lockPin: "",
  calendarId: "",
  calendarProviderId: "",
  mode2Organizer: false,

  //dynamic data below that will be owerriten:
  allDay: false,
  checkInReminderSend: false,
  endTime: "",
  eventTimeZone: "",
  startTime: "",
  organizer: undefined,
  notifyAssignee: false,
};
